module.exports = __webpack_public_path__ + "img/eln.4beb14b0.svg";